module.exports = __webpack_public_path__ + "img/recruit_r.d6d33ff8.png";